import { vestResolver } from '@hookform/resolvers/vest'
import { useIfpFormContext } from '@sec-loans-ui/ifp-loans/steps/formContext'
import { FormStep } from '@sec-loans-ui/ifp-loans/steps/FormStep'
import { MAX_OPTION_VALUE_CHILDREN } from '@sec-loans-ui/ifp-loans/steps/household-info/contants'
import { useWizardForm } from '@ui-common/hooks'
import { buildNumberList } from '@ui-common/utils'
import { getProgressBarProps } from '@ui-common/utils/wizardUtils'
import { useIntl } from 'react-intl'

import { NumberRadioGroup } from '../../../wizard/common/Inputs'
import { getProgressInfo } from '../../utils'
import { createFormValidator } from './formValidator'
import { IfpHouseholdInfoFormData } from './types'

export const HouseholdInfoStep = () => {
  const intl = useIntl()
  const {
    step,
    wizardType,
    wizardData,
    proceed,
    loan: { debtors },
  } = useIfpFormContext()

  const methods = useWizardForm<IfpHouseholdInfoFormData>({
    defaultValues: wizardData?.householdInfo,
    resolver: vestResolver(createFormValidator(intl.formatMessage)),
  })
  const { register, handleSubmit } = methods

  const onSubmit = (formData: IfpHouseholdInfoFormData) => {
    proceed({ householdInfo: formData })
  }

  return (
    <FormStep
      subHeader={intl.formatMessage({ id: 'ifp-loans-household-info-step-heading' })}
      formMethods={methods}
      onSubmit={handleSubmit(onSubmit)}
      showIntroSectionDivider={false}
      progressBarOptions={getProgressBarProps({
        intl,
        progressInfo: getProgressInfo({
          step,
          debtorsCount: debtors.length,
          type: wizardType,
        }),
        showProgressBar: true,
      })}
    >
      <NumberRadioGroup
        required={true}
        label={intl.formatMessage({ id: 'ifp-loans-household-info-adults-label' })}
        options={buildNumberList(1, 2)}
        otherLabel={intl.formatMessage({ id: 'common-how-many' })}
        {...register('numberOfAdults')}
      />
      <NumberRadioGroup
        required={true}
        label={intl.formatMessage({ id: 'ifp-loans-household-info-children-label' })}
        description={intl.formatMessage({ id: 'ifp-loans-household-info-children-description' })}
        options={buildNumberList(0, MAX_OPTION_VALUE_CHILDREN, intl.formatMessage({ id: 'common-more' }))}
        otherLabel={intl.formatMessage({ id: 'common-how-many' })}
        {...register('numberOfChildren')}
      />
    </FormStep>
  )
}
